module.exports = __webpack_public_path__ + "img/design proposal_demo-02.6bc79985.jpg";